/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Invite_HintInputs */

const cs_portal_invite_hint = /** @type {(inputs: Portal_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvolte heslo pro aktivaci portálového účtu.`)
};

const en_portal_invite_hint = /** @type {(inputs: Portal_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a password to activate your portal account.`)
};

/**
* | output |
* | --- |
* | "Choose a password to activate your portal account." |
*
* @param {Portal_Invite_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_invite_hint = /** @type {((inputs?: Portal_Invite_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Invite_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_invite_hint(inputs)
	return cs_portal_invite_hint(inputs)
});